import React from 'react'
import styled from 'styled-components'

import { media } from 'styles/media'

import LazyImage from '../../display/LazyImage'

export type AppearanceProps = {
  vertical?: boolean
  inverseColors?: boolean
}

export const Title = styled.h2`
  font-size: ${({ theme }) => theme['-ds-font-size-lg']['font-size'].value};
  font-weight: 400;
  margin-bottom: 16px;
`

export const Paragraph = styled.p`
  font-size: ${({ theme }) => theme['-ds-font-size-sm']['font-size'].value};
  font-weight: 300;
  line-height: 1.5;
  margin-bottom: 30px;
`

export const LogoWrapper = styled.div<AppearanceProps>`
  position: absolute;
  bottom: 40px;
  right: 20px;

  svg {
    width: 30px;
    color: ${({ theme, inverseColors }) =>
      inverseColors
        ? theme?.['-ds-core-300']?.value
        : theme?.['-ds-neutral-100']?.value};
  }
`

const ImageWrapper = styled.div<AppearanceProps>`
  height: 45%;

  ${media.md`
    ${({ vertical }: AppearanceProps) =>
      !vertical &&
      `
      height: 100%;
      width: 30%;
    `}
  `}
`

const DescriptionWrapper = styled.div<AppearanceProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  box-sizing: border-box;
  height: 55%;
  padding: 16px;

  background-color: ${({ theme, inverseColors }) =>
    inverseColors
      ? theme?.['-ds-neutral-200']?.value
      : theme?.['-ds-core-400']?.value};

  color: ${({ theme, inverseColors }) =>
    inverseColors
      ? theme?.['-ds-core-300']?.value
      : theme?.['-ds-neutral-100']?.value};

  ${media.md`
      padding: 60px;

      ${({ vertical }: AppearanceProps) =>
        !vertical &&
        `
      height: 100%;
      width: 70%;
    `}
  `}
`

const Outer = styled.div<AppearanceProps>`
  overflow: hidden;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  height: 600px;

  ${media.md`
    ${({ vertical }: AppearanceProps) =>
      !vertical &&
      `
      height: 300px;
      flex-direction: row;
    `}
  `}
`

type IllustratedInfoCardProps = {
  image?: { medium: string; large: string }
} & AppearanceProps

const IllustratedInfoCard: React.FC<IllustratedInfoCardProps> = ({
  image,
  vertical,
  inverseColors,
  children,
}) => {
  return (
    <Outer vertical={vertical}>
      <ImageWrapper vertical={vertical}>
        <LazyImage
          data-src={image?.large}
          data-srcset={`
          ${image?.medium} 620w,
          ${image?.large} 1200w,
        `}
        />
      </ImageWrapper>

      <DescriptionWrapper vertical={vertical} inverseColors={inverseColors}>
        {children}
      </DescriptionWrapper>
    </Outer>
  )
}

export default IllustratedInfoCard
